<template>
  <div class="framework-ratings-legend">
      <div class="legend-item"
        v-for="n in 4"
        :key="5 - n">
        <VizFourBarRating class="small"
          :rating="5 - n"
          :xPadding="3"
          :yPadding="0"
          :hollow-style="true"
        />
        <div class="name">{{ descriptionForRating(5 - n) }}</div>
      </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import VizFourBarRating, { descriptionForRating } from '@/components/VizFourBarRating'

@Component({
  methods: {
    descriptionForRating
  },
  components: {
    VizFourBarRating
  }
})
export default class FrameworkRatingsLegend extends Vue {
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './css/const.scss';
.framework-ratings-legend {
  display: flex;
  column-gap: 26px;
  justify-content: start;
  padding-left: 18px;
  font-size: 12px;
  color: #767676;
  .legend-item {
    display: block;
    .viz-four-bar-rating {
      margin: 2px 2px 2px 0px;
    }
    .name {
      /* this forces long text to wrap */
      max-width: 72px;
      margin-top: 3px;
    }
  }

/* Size/colors for rating viz (positioning is above) */
  .viz-four-bar-rating {
    border-color: #999999;
    /deep/ .bar        { fill: #E3E3E3; }
    /deep/ .bar.filled { fill: #999999; }
    &.hollow-style {
      /deep/ .bar {fill: #949494;}
      /deep/ .bar.hollow { fill: white}
    }
  }
}

/* similar code is in FrameworkRatings.vue */
/* upto 956px */
@media screen and (max-width: $screen-width-2-column-small) {
  .framework-ratings-legend {
    padding-left: 0;
    justify-content: space-between;
  }
}

/* upto 644px */
@media screen and (max-width: $screen-width-1-column-large) {
  .framework-ratings-legend {
    column-gap: 26px;
    padding-left: 18px;
    justify-content: start;
  }
}

/* upto 456px */
@media screen and (max-width: $screen-width-1-column-small) {
  .framework-ratings-legend {
    padding-left: 0;
    justify-content: space-between;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/sqs/2025/FrameworkRatingsLegend.vue